import React from 'react'
import styled from '@emotion/styled'
import { Title, TITLE_VARIANT_M } from '../Title'
import { BANNER_VARIANT_PURPLE, BANNER_VARIANT_DEFAULT } from './Banner';
import PropTypes from 'prop-types';

const variantStyles = {
  [BANNER_VARIANT_DEFAULT]: {
    color: '#19a6cd',
  },
  [BANNER_VARIANT_PURPLE]: {
    color: '#ffffff',
  },
}
const getVariantStyle = (variant) => variantStyles[variant] || variantStyles[BANNER_VARIANT_DEFAULT];

const BannerTitleContainer = styled(Title)`
    color: ${({ bannerVariant }) => getVariantStyle(bannerVariant).color};
    font-weight: 500;
`;

export const BannerTitle = ({ children, bannerVariant, ...props }) => (
  <BannerTitleContainer variant={TITLE_VARIANT_M} bannerVariant={bannerVariant} {...props} >
    {children}
  </BannerTitleContainer>
)

BannerTitle.propTypes = {
  children: PropTypes.node.isRequired,
  bannerVariant: PropTypes.oneOf([BANNER_VARIANT_PURPLE, BANNER_VARIANT_DEFAULT])
}